import { createModel } from "hox";
import { useState, useEffect } from "react";
import { IReportBillDetail, IReportBillSearch } from "./reportBillType";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, } from "@/utils/constants";
import { TablePaginationConfig } from "antd/es/table/interface";
import { transPgToPagination } from "@/utils/utils";
import { ISearchPage } from "@/types/ScmTypes";
import { reportBillService } from "./reportBillService";
import { sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import useGlobalModel from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";

export const useReportBillModel = createModel(function () {
    const { shopAndOrg, user, user: { roles, username } } = useGlobalModel()
    //切换站点清除缓存
    useEffect(() => { reset(); }, [shopAndOrg.shopCode])
    const initSearchParam: IReportBillSearch = {};
    // status: ["repair_report.init", "repair_report.ing"] 
    const initDataSource: IReportBillDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<IReportBillSearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IReportBillDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //表格选中的值
    const [selectedRow, setSelectedRow] = useState<IReportBillDetail>({});

    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //派工抽屉
    const [dispatchVisible, setDispatchVisible] = useState<boolean>(false);
    //日志抽屉
    const [logVisible, setLogVisible] = useState<boolean>(false);
    //日志抽屉
    const [reportVisible, setReportVisible] = useState<boolean>(false);
    //审核弹窗
    const [checkAcceptVisible, setCheckAcceptVisible] = useState<boolean>(false);
    //弹框状态值
    const [detailType, setDetailType] = useState<string>("");

    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedRow(selectedData as IReportBillDetail)
    }, [selectedRowKeys])

    const updateSearchParam = (updateParam: IReportBillSearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
    }
    const reset = () => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([])
    }
    const loadData = async (page?: ISearchPage, searchValue: IReportBillSearch = searchParam) => {
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };

        const searchParams = {

            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            orgName: user.orgType == 'out' ? user.orgName : null,
            orgCode: user.orgType == 'out' ? user.orgCode : null,
            depName: user.orgType == 'out' ? user.depName : null,
            depCode: user.orgType == 'out' ? user.depCode : null,
            createUser: roles.length === 1 && roles[0] === 'hd-z.f' ? user.userName : null,
            ...shopParam,
            ...searchValue,
            status: searchValue?.status?.length > 0 ? searchValue.status.toString() : null
        }
        let { retData } = await reportBillService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records)
    }
    const exportMaintenance = async (searchValue: IReportBillSearch = searchParam) => {
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };
        const searchParams = {
            id: selectedRowKeys.join(),
            orgName: user.orgType == 'out' ? user.orgName : null,
            orgCode: user.orgType == 'out' ? user.orgCode : null,
            depName: user.orgType == 'out' ? user.depName : null,
            depCode: user.orgType == 'out' ? user.depCode : null,
            createUser: roles.length === 1 && roles[0] === 'hd-z.f' ? user.userName : null,
            ...shopParam,
            ...searchValue,
            ...shopParam,
            status: searchValue?.status?.length > 0 ? searchValue.status.toString() : null
        }
        let result = await reportBillService.export(searchParams);
        convertRes2Blob(result)
    }
    return {
        searchParam,
        dataSource,
        selectedRowKeys,
        selectedRow,
        pgCfg,
        initPgCfg,
        dispatchVisible,
        setSearchParam,
        setDataSource,
        setSelectedRowKeys,
        setSelectedRow,
        setPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData,
        detailType, setDetailType,
        setDispatchVisible,
        reset,
        exportMaintenance,
        checkAcceptVisible, setCheckAcceptVisible,
        logVisible, setLogVisible,
        reportVisible, setReportVisible
    }
})